(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6683],{

/***/ 66704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ VehicleConditionBadge; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./components/atomic/VehicleConditionBadge/vehicle-condition-badge.module.scss
var vehicle_condition_badge_module = __webpack_require__(19074);
var vehicle_condition_badge_module_default = /*#__PURE__*/__webpack_require__.n(vehicle_condition_badge_module);
;// CONCATENATED MODULE: ./components/atomic/VehicleConditionBadge/VehicleConditionBadge.js





var VehicleConditionBadge = function(param) {
    var _isElectric = param.isElectric, isElectric = _isElectric === void 0 ? false : _isElectric, _size = param.size, size = _size === void 0 ? "xs" : _size, _label = param.label, label = _label === void 0 ? "New" : _label, _hasCommaAfter = param.hasCommaAfter, hasCommaAfter = _hasCommaAfter === void 0 ? false : _hasCommaAfter;
    if (isElectric) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            className: "".concat((vehicle_condition_badge_module_default()).badge, " ").concat((vehicle_condition_badge_module_default()).electric, " ").concat((vehicle_condition_badge_module_default())[size]),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/icons/library/zap-electric.svg"),
                    height: 14,
                    width: 14,
                    alt: "Electric zap icon"
                }),
                " ",
                "Electric",
                hasCommaAfter && ","
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: "".concat((vehicle_condition_badge_module_default()).badge, " ").concat((vehicle_condition_badge_module_default())["new"], " ").concat((vehicle_condition_badge_module_default())[size]),
        children: [
            label,
            hasCommaAfter && ","
        ]
    });
};
VehicleConditionBadge.propTypes = {
    isElectric: (prop_types_default()).bool.isRequired,
    size: (prop_types_default()).string.isRequired,
    label: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./components/atomic/VehicleConditionBadge/index.js



/***/ }),

/***/ 50422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* reexport */ Badge; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/styleguide/Badge/badge.module.scss
var badge_module = __webpack_require__(3154);
var badge_module_default = /*#__PURE__*/__webpack_require__.n(badge_module);
;// CONCATENATED MODULE: ./components/styleguide/Badge/Badge.tsx


var Badge = function(param) {
    var label = param.label, _className = param.className, className = _className === void 0 ? "" : _className, _type = param.type, type = _type === void 0 ? "standard" : _type;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "".concat((badge_module_default()).main, " ").concat(className),
        "data-badge-type": type,
        children: label
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Badge/index.ts



/***/ }),

/***/ 6683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Title; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(80969);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./components/styleguide/Configurator/Title/title.module.scss
var title_module = __webpack_require__(79344);
var title_module_default = /*#__PURE__*/__webpack_require__.n(title_module);
// EXTERNAL MODULE: ./components/atomic/VehicleConditionBadge/index.js + 1 modules
var VehicleConditionBadge = __webpack_require__(66704);
// EXTERNAL MODULE: ./components/styleguide/Badge/index.ts + 1 modules
var Badge = __webpack_require__(50422);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/styleguide/Configurator/Breadcrumb/breadcrumb.module.scss
var breadcrumb_module = __webpack_require__(57604);
var breadcrumb_module_default = /*#__PURE__*/__webpack_require__.n(breadcrumb_module);
// EXTERNAL MODULE: ./lib/utilities/system.js + 1 modules
var system = __webpack_require__(70591);
;// CONCATENATED MODULE: ./components/styleguide/Configurator/Breadcrumb/BreadcrumbItem.tsx




var BreadcrumbItem = function(param) {
    var index = param.index, link = param.link, label = param.label;
    if (link.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: "".concat((breadcrumb_module_default()).crumb, " ").concat((breadcrumb_module_default()).text, " ").concat(!(0,system/* isProd */.BB)() ? "breadcrumb_".concat(index) : ""),
            children: label
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: link,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "".concat((breadcrumb_module_default()).crumb, " ").concat(!(0,system/* isProd */.BB)() ? "breadcrumb_".concat(index) : ""),
            children: label
        })
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Configurator/Breadcrumb/Breadcrumb.tsx






var Breadcrumb = function(param) {
    var breadcrumbs = param.breadcrumbs;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (breadcrumb_module_default()).container,
        children: breadcrumbs.map(function(item, index) {
            var crumb = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                index: index
            });
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    index > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "\xb7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbItem, (0,_object_spread/* default */.Z)({}, crumb), item.label)
                ]
            }, item.label);
        })
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Configurator/Breadcrumb/index.tsx



// EXTERNAL MODULE: ./lib/animations/TextSwitchTransition/index.ts + 1 modules
var TextSwitchTransition = __webpack_require__(19086);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./lib/hooks/useExperiment.ts
var useExperiment = __webpack_require__(46389);
// EXTERNAL MODULE: ./lib/utilities/search.js
var search = __webpack_require__(45425);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var utilities_vehicle = __webpack_require__(13732);
;// CONCATENATED MODULE: ./components/styleguide/Configurator/Title/Title.tsx














var Title = function(param) {
    var vehicle = param.vehicle, isSticky = param.isSticky, selectedVehiclePrice = param.selectedVehiclePrice, _pageType = param.pageType, pageType = _pageType === void 0 ? "config" : _pageType;
    var isDesktop = (0,react_responsive.useMediaQuery)({
        minWidth: 992
    });
    var ref = (0,react.useState)("0.00"), monthlyPrice = ref[0], setMonthlyPrice = ref[1];
    var ref1 = (0,react.useState)(true), includeVat = ref1[0], setIncludeVat = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useExperiment/* useExperiment */.a)(), 1), experimentGroup = ref2[0];
    var ref3 = (0,react.useState)("control"), version = ref3[0], setVersion = ref3[1];
    (0,react.useEffect)(function() {
        if (experimentGroup.startsWith("edit-lease-placement-variant")) {
            setVersion(experimentGroup.split("edit-lease-placement-")[1]);
        }
    }, [
        experimentGroup
    ]);
    (0,react.useEffect)(function() {
        if (selectedVehiclePrice) {
            setMonthlyPrice(selectedVehiclePrice.leaseType === constants/* FILTER_LEASE_TYPES_PERSONAL */.m_ ? (0,search/* addVatToPrice */.QR)(selectedVehiclePrice.monthlyPayment) : selectedVehiclePrice.monthlyPayment.toFixed(2));
        }
    }, [
        selectedVehiclePrice
    ]);
    (0,react.useEffect)(function() {
        if (selectedVehiclePrice) {
            setIncludeVat(selectedVehiclePrice.leaseType === constants/* FILTER_LEASE_TYPES_PERSONAL */.m_);
        }
    }, [
        selectedVehiclePrice
    ]);
    var breadcrumbs = [
        {
            label: "".concat(vehicle.manufacturerName),
            link: "/".concat(vehicle.type === constants/* FILTER_VEHICLE_TYPES_VANS */.Bz ? "van" : "car", "-leasing/").concat((0,utilities_vehicle/* getUrlReadyString */.oh)(vehicle.manufacturerName))
        },
        {
            label: "".concat(vehicle.rangeName),
            link: "/".concat(vehicle.type === constants/* FILTER_VEHICLE_TYPES_VANS */.Bz ? "van" : "car", "-leasing/").concat((0,utilities_vehicle/* getUrlReadyString */.oh)(vehicle.manufacturerName), "/").concat((0,utilities_vehicle/* getUrlReadyString */.oh)(vehicle.rangeName))
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((title_module_default()).container, " ").concat(isSticky ? (title_module_default())["is-sticky"] : "", " ").concat(pageType === "landing" ? (title_module_default())["ad-title"] : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (title_module_default()).titles,
                children: [
                    pageType === "config" && (selectedVehiclePrice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                className: (title_module_default())["stock-status-badge"],
                                type: "stock-status",
                                label: selectedVehiclePrice.stockStatus === 0 ? "Factory order" : "In stock"
                            }),
                            vehicle.fuelType === 5 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                label: "Electric",
                                type: "electric"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleConditionBadge/* VehicleConditionBadge */.Z, {
                        isElectric: vehicle.fuelType === 5,
                        size: "sm"
                    })),
                    isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                className: !(0,system/* isProd */.BB)() ? "vehicle-name__h1" : "",
                                children: [
                                    pageType !== "config" && vehicle.manufacturerName,
                                    " ",
                                    vehicle.modelName,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSwitchTransition/* TextSwitchTransition */.d, {
                                        text: vehicle.derivativeName
                                    })
                                ]
                            }),
                            version === "control" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                className: (title_module_default()).subtitle,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (title_module_default()).large,
                                        children: [
                                            "\xa3",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSwitchTransition/* TextSwitchTransition */.d, {
                                                text: monthlyPrice.toString().slice(0, -2)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSwitchTransition/* TextSwitchTransition */.d, {
                                        text: monthlyPrice.toString().slice(-2)
                                    }),
                                    "/pm ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSwitchTransition/* TextSwitchTransition */.d, {
                                        text: includeVat ? "incl." : "excl."
                                    }),
                                    " VAT"
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                className: !(0,system/* isProd */.BB)() ? "vehicle-name__h1" : "",
                                children: [
                                    pageType !== "config" && vehicle.manufacturerName,
                                    " ",
                                    vehicle.modelName
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: vehicle.derivativeName
                            })
                        ]
                    })
                ]
            }),
            pageType === "config" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb, {
                breadcrumbs: breadcrumbs
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Configurator/Title/index.tsx



/***/ }),

/***/ 19086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* reexport */ TextSwitchTransition; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/SwitchTransition.js
var SwitchTransition = __webpack_require__(45989);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js + 3 modules
var CSSTransition = __webpack_require__(76743);
// EXTERNAL MODULE: ./lib/animations/TextSwitchTransition/text-switch-transition.module.scss
var text_switch_transition_module = __webpack_require__(89398);
var text_switch_transition_module_default = /*#__PURE__*/__webpack_require__.n(text_switch_transition_module);
;// CONCATENATED MODULE: ./lib/animations/TextSwitchTransition/TextSwitchTransition.tsx




var TextSwitchTransition = function(param) {
    var text = param.text;
    var nodeRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchTransition/* default */.Z, {
        mode: "out-in",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
            nodeRef: nodeRef,
            addEndListener: function(done) {
                var ref;
                (ref = nodeRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("transitionend", done, false);
            },
            classNames: {
                enter: "".concat((text_switch_transition_module_default()).enter, " ").concat((text_switch_transition_module_default()).slide),
                enterActive: (text_switch_transition_module_default())["enter--active"],
                enterDone: "".concat((text_switch_transition_module_default())["enter--done"], " ").concat((text_switch_transition_module_default()).slide),
                exit: "".concat((text_switch_transition_module_default()).exit, " ").concat((text_switch_transition_module_default()).slide),
                exitActive: (text_switch_transition_module_default())["exit--active"],
                exitDone: "".concat((text_switch_transition_module_default())["exit--done"], " ").concat((text_switch_transition_module_default()).slide)
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                ref: nodeRef,
                children: text
            })
        }, text)
    });
};

;// CONCATENATED MODULE: ./lib/animations/TextSwitchTransition/index.ts



/***/ }),

/***/ 19074:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"badge":"vehicle-condition-badge_badge__iiiY9","xs":"vehicle-condition-badge_xs__aXevS","sm":"vehicle-condition-badge_sm__FeGys","electric":"vehicle-condition-badge_electric__pEZ4l","new":"vehicle-condition-badge_new__1eAcc","phAnimation":"vehicle-condition-badge_phAnimation__B4bOe"};

/***/ }),

/***/ 3154:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"badge_main__h8Whe","phAnimation":"badge_phAnimation__junPt"};

/***/ }),

/***/ 57604:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"breadcrumb_container__2jeNL","crumb":"breadcrumb_crumb__8xsP1","text":"breadcrumb_text__fg81S","phAnimation":"breadcrumb_phAnimation__neUoQ"};

/***/ }),

/***/ 79344:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"title_container__2a9gw","ad-title":"title_ad-title__R5C_m","is-sticky":"title_is-sticky__NQOQ1","titles":"title_titles__VoN2l","subtitle":"title_subtitle__a0dNN","stock-status-badge":"title_stock-status-badge__8wegR","phAnimation":"title_phAnimation__QOx1g"};

/***/ }),

/***/ 89398:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slide":"text-switch-transition_slide__ONYgZ","enter":"text-switch-transition_enter__5PajH","enter--active":"text-switch-transition_enter--active__9R8fU","enter--done":"text-switch-transition_enter--done__W2Gnr","exit":"text-switch-transition_exit__JqB_c","exit--active":"text-switch-transition_exit--active__PoSzO","phAnimation":"text-switch-transition_phAnimation__H1qE1"};

/***/ })

}]);